import React from "react";

import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

function DocumentIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7" aria-hidden="true">
            <path d="M7 3h7l4 4v14H7V3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
            <path d="M14 3v5h4M9.5 12h5M9.5 15.5h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    );
}

function UserIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" aria-hidden="true">
            <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.6" />
            <path d="M5.5 20c.7-4 3-6 6.5-6s5.8 2 6.5 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    );
}

function MailIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
            <path d="M4 6h16v12H4V6Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
            <path d="m5 7 7 6 7-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function LocationIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
            <path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z" stroke="currentColor" strokeWidth="1.6" />
            <circle cx="12" cy="10" r="2" stroke="currentColor" strokeWidth="1.6" />
        </svg>
    );
}

function BriefcaseIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
            <path d="M4 8h16v11H4V8Zm5-3h6v3H9V5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
            <path d="M4 12h16" stroke="currentColor" strokeWidth="1.6" />
        </svg>
    );
}

function ArrowUpRight() {
    return (
        <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4" aria-hidden="true">
            <path d="M7 17 17 7M9 7h8v8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

const officers = [
    {
        number: "01",
        role: "Public Information Officer",
        shortRole: "PIO",
        name: "Mr. Diamond Sahu",
        designation: "Asst. Prof. School of Arts & Humanities",
        email: "diamondkumar.sahu@isbmuniversity.edu.in",
        accent: "navy",
    },
    {
        number: "02",
        role: "First Appellate Authority",
        shortRole: "Appellate Authority",
        name: "Dr. Barada Prasad Bhol",
        designation: "Registrar & First Appellate Authority",
        email: "b.bhol@isbmuniversity.edu.in",
        accent: "burgundy",
    },
];

const addressLines = [
    "ISBM University, Nawapara (Kosmi)",
    "Block & Tehsil – Chhura",
    "District – Gariyaband",
    "Chhattisgarh – 493996",
];

export default function RTI() {
    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />

            <main className="bg-white text-[#132337]">

                {/* UNIQUE RTI HERO */}
                <section className="relative overflow-hidden bg-[#071A2F] pt-[100px] text-white">

                    {/* BACKGROUND DETAILS */}
                    <div className="pointer-events-none absolute inset-0">

                        <div className="absolute inset-0 bg-[radial-gradient(circle_at_72%_45%,rgba(213,173,87,0.08),transparent_34%)]" />

                        <div className="absolute bottom-0 right-0 h-[72%] w-[46%] border-l border-t border-white/[0.07]" />

                        <div className="absolute bottom-0 right-0 h-[72%] w-[46%] opacity-[0.035] [background-image:linear-gradient(rgba(255,255,255,.8)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.8)_1px,transparent_1px)] [background-size:44px_44px]" />

                        <div className="absolute left-0 top-[100px] h-px w-full bg-white/[0.06]" />

                        <div className="absolute bottom-0 left-0 h-[5px] w-[32%] bg-[#8B1E3F]" />

                        <div className="absolute bottom-0 left-[32%] h-[5px] w-[13%] bg-[#D5AD57]" />

                    </div>


                    <div className="relative mx-auto min-h-[620px] w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid min-h-[620px] lg:grid-cols-[1.08fr_.92fr]">

                            {/* LEFT CONTENT */}
                            <div className="relative z-10 flex flex-col justify-center pb-16 pr-8 lg:pb-20 lg:pr-16">

                                {/* EYEBROW */}
                                <div className="flex items-center gap-4">

                                    <span className="grid h-10 w-10 place-items-center border border-[#D5AD57]/40">

                                        <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5 text-[#D5AD57]" aria-hidden="true">
                                            <path d="M7 3h7l4 4v14H7V3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                                            <path d="M14 3v5h4M9.5 12h5M9.5 15.5h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                        </svg>

                                    </span>

                                    <div>

                                        <span className="block text-[9px] font-bold uppercase tracking-[0.2em] text-[#D5AD57]">
                                            Statutory Information
                                        </span>

                                        <span className="mt-1 block text-[11px] font-semibold uppercase tracking-[0.12em] text-white/45">
                                            Right to Information Act
                                        </span>

                                    </div>

                                </div>


                                {/* TITLE */}
                                <h1 className="mt-9 max-w-[760px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,6.3vw,90px)] font-normal leading-[0.94] tracking-[-0.045em]">

                                    Right to

                                    <span className="block text-[#D5AD57]">
                                        Information.
                                    </span>

                                </h1>


                                {/* SUBTITLE */}
                                <div className="mt-8 grid max-w-[730px] grid-cols-[3px_1fr] gap-6">

                                    <div className="bg-[#8B1E3F]" />

                                    <div>

                                        <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[22px] leading-[1.4] text-white/90">
                                            RTI Act 2005 Compliance
                                        </p>

                                        <p className="mt-3 max-w-[650px] text-[15px] leading-7 text-white/55">
                                            Details of PIO and Appellate Authority of ISBM University Under RTI Act 2005.
                                        </p>

                                    </div>

                                </div>


                                {/* BOTTOM LABELS */}
                                <div className="mt-11 flex flex-wrap gap-3">

                                    {[
                                        "Transparency",
                                        "Accountability",
                                        "Access to Information",
                                    ].map((item) => (
                                        <span key={item} className="border border-white/10 px-4 py-2.5 text-[9px] font-bold uppercase tracking-[0.14em] text-white/50">
                                            {item}
                                        </span>
                                    ))}

                                </div>

                            </div>


                            {/* RIGHT VISUAL */}
                            <div className="relative hidden min-h-[420px] lg:block">

                                {/* LARGE RTI TYPOGRAPHY */}
                                <div className="absolute inset-0 flex items-start justify-center">

                                    <div className="relative -translate-y-4 pt-[90px]">

                                        <span className="block font-['Libre_Caslon_Display',Georgia,serif] text-[190px] font-normal leading-[0.72] tracking-[-0.09em] text-transparent [-webkit-text-stroke:1px_rgba(213,173,87,0.25)]">
                                            RTI
                                        </span>

                                        <div className="mt-8 flex items-end justify-between">

                                            <span className="text-[16px] font-bold uppercase tracking-[0.25em] text-white/30">
                                                Act
                                            </span>

                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[78px] font-normal leading-none text-[#D5AD57]">
                                                2005
                                            </span>

                                        </div>

                                    </div>

                                </div>


                                {/* DOCUMENT CARD */}
                                <div className="absolute bottom-[52px] left-[15px] right-0 bg-white p-1 shadow-2xl shadow-black/20">

                                    <div className="border border-[#071A2F]/10 bg-[#F7F2E8] p-6">

                                        <div className="flex items-center justify-between border-b border-[#071A2F]/10 pb-4">

                                            <span className="text-[9px] font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">
                                                Designated RTI Authorities
                                            </span>

                                            <span className="text-[9px] font-bold uppercase tracking-[0.14em] text-[#071A2F]/35">
                                                ISBM University
                                            </span>

                                        </div>


                                        <div className="grid grid-cols-2">

                                            {/* PIO */}
                                            <div className="border-r border-[#071A2F]/10 py-5 pr-5">

                                                <div className="flex items-start gap-4">

                                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[25px] text-[#D5AD57]">
                                                        01
                                                    </span>

                                                    <div>

                                                        <span className="text-[9px] font-bold uppercase leading-4 tracking-[0.11em] text-[#8B1E3F]">
                                                            Public Information Officer
                                                        </span>

                                                        <p className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[19px] leading-[1.2] text-[#071A2F]">
                                                            Mr. Diamond Sahu
                                                        </p>

                                                    </div>

                                                </div>

                                            </div>


                                            {/* APPELLATE */}
                                            <div className="py-5 pl-5">

                                                <div className="flex items-start gap-4">

                                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[25px] text-[#D5AD57]">
                                                        02
                                                    </span>

                                                    <div>

                                                        <span className="text-[9px] font-bold uppercase leading-4 tracking-[0.11em] text-[#8B1E3F]">
                                                            First Appellate Authority
                                                        </span>

                                                        <p className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[19px] leading-[1.2] text-[#071A2F]">
                                                            Dr. Barada Prasad Bhol
                                                        </p>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>


                                        {/* DOCUMENT FOOTER */}
                                        <div className="flex items-center justify-between border-t border-[#071A2F]/10 pt-4">

                                            <span className="text-[8px] font-bold uppercase tracking-[0.16em] text-[#071A2F]/35">
                                                Information • Transparency • Accountability
                                            </span>

                                            <span className="h-2 w-2 rotate-45 bg-[#8B1E3F]" />

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>


                    {/* MOBILE RTI BLOCK */}
                    <div className="relative border-t border-white/10 px-4 py-8 lg:hidden">

                        <div className="mx-auto flex max-w-[600px] items-center justify-between">

                            <div>

                                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[58px] leading-none text-[#D5AD57]">
                                    2005
                                </span>

                                <span className="mt-2 block text-[9px] font-bold uppercase tracking-[0.18em] text-white/40">
                                    Right to Information Act
                                </span>

                            </div>

                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[70px] leading-none text-transparent [-webkit-text-stroke:1px_rgba(213,173,87,0.3)]">
                                RTI
                            </span>

                        </div>

                    </div>

                </section>


                {/* RTI INTRODUCTION */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-12 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.7fr_1.3fr] lg:gap-20">

                        <div>
                            <Eyebrow>RTI Act 2005 Compliance</Eyebrow>

                            <Title before="Openness Through" highlight="Information & Accountability" after="" position="middle" theme="burgundy" />
                        </div>


                        <div className="lg:pt-7">

                            <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(27px,3vw,42px)] font-normal leading-[1.35] text-[#071A2F]">
                                Details of PIO and Appellate Authority of ISBM University Under RTI Act 2005.
                            </p>

                            <p className="mt-8 max-w-[850px] text-[15px] leading-8 text-[#65727E]">
                                ISBM University also aligns with the Right to Information (RTI) Act, reinforcing our commitment to transparency and accountability. We empower students, parents, and stakeholders to seek relevant institutional information as permitted by law. This approach not only builds trust but also reflects our openness in delivering a student-first experience driven by honesty, clarity, and continuous improvement.
                            </p>

                        </div>

                    </div>

                </section>


                {/* AUTHORITY DIRECTORY */}
                <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-11 lg:grid-cols-[1fr_430px] lg:items-end">

                            <div>
                                <Eyebrow>RTI Authorities</Eyebrow>

                                <Title before="Designated Officers for" highlight="Information & Appeal" after="" position="middle" theme="burgundy" />
                            </div>

                            <p className="text-[15px] leading-8 text-[#65727E]">
                                Contact the designated authority according to the nature and stage of your RTI-related communication.
                            </p>

                        </div>


                        {/* OFFICERS */}
                        <div className="mt-14 grid gap-6 lg:grid-cols-2">

                            {officers.map((officer, index) => (
                                <article key={officer.number} className="group overflow-hidden border border-[#071A2F]/10 bg-white">

                                    {/* TOP */}
                                    <div className={`relative p-8 text-white sm:p-10 ${officer.accent === "navy" ? "bg-[#071A2F]" : "bg-[#8B1E3F]"}`}>

                                        <div className="absolute right-7 top-4 font-['Libre_Caslon_Display',Georgia,serif] text-[90px] font-normal leading-none text-white/[0.06]">
                                            {officer.number}
                                        </div>

                                        <div className="relative">

                                            <div className="flex items-start justify-between gap-5">

                                                <div className="grid h-14 w-14 place-items-center rounded-full border border-[#D5AD57]/40 text-[#D5AD57]">
                                                    <UserIcon />
                                                </div>

                                                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[30px] font-normal text-[#D5AD57]">
                                                    {officer.number}
                                                </span>

                                            </div>


                                            <span className="mt-9 block text-[9px] font-bold uppercase tracking-[0.17em] text-[#D5AD57]">
                                                RTI Act 2005
                                            </span>

                                            <h3 className="mt-3 max-w-[470px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(30px,3vw,42px)] font-normal leading-[1.1]">
                                                {officer.role}
                                            </h3>

                                        </div>

                                    </div>


                                    {/* DETAILS */}
                                    <div className="p-8 sm:p-10">

                                        {/* NAME */}
                                        <div className="grid gap-4 border-b border-[#071A2F]/10 pb-6 sm:grid-cols-[145px_1fr]">

                                            <div className="flex items-center gap-3 text-[#8B1E3F]">
                                                <UserIcon />

                                                <span className="text-[9px] font-bold uppercase tracking-[0.15em]">
                                                    Name
                                                </span>
                                            </div>

                                            <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal text-[#071A2F]">
                                                {officer.name}
                                            </strong>

                                        </div>


                                        {/* DESIGNATION */}
                                        <div className="grid gap-4 border-b border-[#071A2F]/10 py-6 sm:grid-cols-[145px_1fr]">

                                            <div className="flex items-center gap-3 text-[#8B1E3F]">
                                                <BriefcaseIcon />

                                                <span className="text-[9px] font-bold uppercase tracking-[0.15em]">
                                                    Designation
                                                </span>
                                            </div>

                                            <p className="text-[14px] font-semibold leading-7 text-[#52606C]">
                                                {officer.designation}
                                            </p>

                                        </div>


                                        {/* ADDRESS */}
                                        <div className="grid gap-4 border-b border-[#071A2F]/10 py-6 sm:grid-cols-[145px_1fr]">

                                            <div className="flex items-start gap-3 text-[#8B1E3F]">
                                                <LocationIcon />

                                                <span className="text-[9px] font-bold uppercase tracking-[0.15em]">
                                                    Address
                                                </span>
                                            </div>

                                            <address className="not-italic text-[14px] leading-7 text-[#52606C]">
                                                {addressLines.map((line) => (
                                                    <span key={line} className="block">
                                                        {line}
                                                    </span>
                                                ))}
                                            </address>

                                        </div>


                                        {/* EMAIL */}
                                        <div className="grid gap-4 pt-6 sm:grid-cols-[145px_1fr]">

                                            <div className="flex items-center gap-3 text-[#8B1E3F]">
                                                <MailIcon />

                                                <span className="text-[9px] font-bold uppercase tracking-[0.15em]">
                                                    Email
                                                </span>
                                            </div>

                                            <a href={`mailto:${officer.email}`} className="group/link inline-flex w-fit items-center gap-3 break-all text-[14px] font-semibold text-[#071A2F] transition hover:text-[#8B1E3F]">

                                                {officer.email}

                                                <span className="shrink-0 text-[#8B1E3F] transition group-hover/link:translate-x-1 group-hover/link:-translate-y-1">
                                                    <ArrowUpRight />
                                                </span>

                                            </a>

                                        </div>

                                    </div>

                                </article>
                            ))}

                        </div>

                    </div>

                </section>


                {/* HOW THE STRUCTURE WORKS */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[.68fr_1.32fr] lg:gap-20">

                            <div>
                                <Eyebrow>Information Structure</Eyebrow>

                                <Title before="A Clear Route for" highlight="RTI Communication" after="" position="middle" theme="burgundy" />
                            </div>


                            <div className="border-t border-[#071A2F]/15">

                                {/* STEP 1 */}
                                <div className="grid gap-6 border-b border-[#071A2F]/15 py-8 sm:grid-cols-[70px_190px_1fr] sm:items-center">

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[36px] text-[#D5AD57]">
                                        01
                                    </span>

                                    <strong className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                                        Information
                                    </strong>

                                    <div>
                                        <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[27px] font-normal text-[#071A2F]">
                                            Public Information Officer
                                        </h3>

                                        <p className="mt-2 text-[14px] leading-7 text-[#65727E]">
                                            Mr. Diamond Sahu
                                        </p>
                                    </div>

                                </div>


                                {/* STEP 2 */}
                                <div className="grid gap-6 border-b border-[#071A2F]/15 py-8 sm:grid-cols-[70px_190px_1fr] sm:items-center">

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[36px] text-[#D5AD57]">
                                        02
                                    </span>

                                    <strong className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                                        Appeal
                                    </strong>

                                    <div>
                                        <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[27px] font-normal text-[#071A2F]">
                                            First Appellate Authority
                                        </h3>

                                        <p className="mt-2 text-[14px] leading-7 text-[#65727E]">
                                            Dr. Barada Prasad Bhol
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>


                {/* CLOSING */}
                <section className="bg-[#8B1E3F] text-white">

                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] lg:grid-cols-[.7fr_1.3fr]">

                        <div className="border-b border-white/10 py-16 lg:border-b-0 lg:border-r lg:py-20 lg:pr-14">

                            <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                Transparency & Accountability
                            </span>

                            <h2 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal leading-[1.1]">
                                Information builds confidence.
                            </h2>

                        </div>


                        <div className="flex items-center py-16 lg:py-20 lg:pl-16">

                            <p className="max-w-[760px] text-[16px] leading-8 text-white/65">
                                Our alignment with the Right to Information Act reflects ISBM University's commitment to openness, honesty, clarity and responsible institutional communication.
                            </p>

                        </div>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
}